export default "__VITE_ASSET__B$eqNyEJ__"